import React, {useState} from 'react';
import {buildCSSFormGroupInput} from "../../../../utils/BubblyUIUtils";
import {doesEmailRespectPattern} from "../../../../utils/BubblyUtils";
import {connect} from "react-redux";
import {saveUserActivationData} from "../../../../slices/userSlice";
import {withToastManager} from "react-toast-notifications";
import {Link, withRouter} from 'react-router-dom';
import AuthenticationService from "../../../../services/Authentication/AuthenticationService";
import LoadingIndicator from "../../../meta/LoadingIndicator";

function LoginForm(props){

    const [userEmail, updateUserEmail] = useState("");
    const [password, updatePassword] = useState("");
    const [showPassword, updateShowPassword] = useState(false);
    const [userEmailValid, updateUserEmailValid] = useState(undefined);
    const [passwordValid, updatePasswordValid] = useState(undefined);
    const [loginLoading, updateLoginLoading] = useState(undefined);

    function onEmailChange(event){
        const email = event.target.value;
        if(email.includes(" ")) {
            return;
        }
        updateUserEmail(email);
        const isEmailValid = doesEmailRespectPattern(email);
        updateUserEmailValid(isEmailValid);
        buildCSSFormGroupInput(event, "loginEmailFormGroup", "loginEmailFormGroupError", isEmailValid);
    }

    function onPasswordChange(event){
        const password = event.target.value;
        updatePassword(password);
        updatePasswordValid(password !== "");
    }

    function toggleShowPassword() {
        updateShowPassword(!showPassword);
    }

    function onLogInAction(event){
        updateLoginLoading(true);
        AuthenticationService.defaultLogin(userEmail, password, null, null,
            (success) => {
                updateLoginLoading(false);
                props.saveUserActivationData(success.data.user_id, success.data.token, success.data.level);
                props.history.push('/surveys');
            },
            (error) => {
                updateLoginLoading(false);
                if (error.status === 401 || error.data.code === window.bubblyWebsiteConfig.CODE_USER_NON_EXISTENT) {
                    props.toastManager.add("Incorrect email or password. Please try again.", {
                        appearance: 'error'
                    });
                }
                else {
                    props.toastManager.add("Error while trying to login to the account, please contact Questia!", {
                        appearance: 'error'
                    });
                }
            }
        );
        event.preventDefault();
    }

    function onForgotPasswordAction(event){
        event.preventDefault();
    }

    const credentialsInvalid = !userEmailValid || !passwordValid;

    return(
        <React.Fragment>
            <h1 className="pt-md pb-xl">Log in to your account</h1>
            <form action="" className="form pt-sm" onSubmit={onLogInAction}>
                <div className="form__group" id="loginEmailFormGroup">
                    <div className="form__group__input">
                        <input className="form__group__input__text" type="text" placeholder="youremail@example.com" value={userEmail} disabled={loginLoading} onChange={onEmailChange}/>
                            <span className="form__group__input__icon"><img src="assets/img/login_page/mail.png"
                                                                            alt=""/></span>
                            <span className="form__group__input_check"><img
                                src="assets/img/login_page/icon-check--green.png" alt=""/></span>
                    </div>
                    <span className="form__group__error form__group__error--email" id="loginEmailFormGroupError">Invalid email</span>
                </div>
                <div className="form__group">
                    <div className="form__group__input">
                        <input className="form__group__input__text"
                               type={showPassword ? "text" : "password"}
                               placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;"
                               disabled={loginLoading}
                               onChange={onPasswordChange} />
                        <span className="form__group__input__toggle" onClick={toggleShowPassword}></span>
                        <span className="form__group__input__icon"><img src="assets/img/login_page/lock.png"
                                                                            alt=""/></span>
                    </div>
                </div>
                <div className="cta__wrapp pv-xs">
                    {
                        loginLoading && <LoadingIndicator/>
                    }
                    {
                        !loginLoading &&
                        (
                            <input type="submit"
                                   id="loginSubmit"
                                   className={credentialsInvalid ? "cta--normal cta--fullwidth cta--disabled cta-join-js" : "cta--normal cta--fullwidth cta-join-js"}
                                   disabled={credentialsInvalid}
                                   value={"Log me in"}/>
                        )
                    }
                </div>
                <div className="cta__wrapp pv-xs">
                    {/*<a href="javascript:void(0);" onClick={onForgotPasswordAction} className="cta--text cta--notransform">Forgot password?</a>*/}
                    {/*<Link to="/passForgot" onClick={onForgotPasswordAction} className="cta--text cta--notransform">Forgot password?</Link>*/}
                    <Link to="/password-reset" className="cta--text cta--notransform">Forgot password?</Link>
                </div>
            </form>
        </React.Fragment>
    )
}

const mapDispatchToProps = {saveUserActivationData};

export default connect(null, mapDispatchToProps)(withRouter(withToastManager(LoginForm)));